// extracted by mini-css-extract-plugin
export default {"Prefix":"_Prefix--Bh0D5","FormattedPrice":"_FormattedPrice--Z9Und","Postfix":"_Postfix--NkezT"};